// extracted by mini-css-extract-plugin
export default {"classroomList":"Home_classroomList__1rPNe"};